// LIBRERIE/IMPORTS
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { faChartLine, faCoins, faDoorOpen, faFolderClosed, faGavel, faHouseChimney, faMagnifyingGlass, faMedal, faStar, faUsers, faUserTie, faVrCardboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

const Services: React.FC = () => {
    const { t } = useTranslation();

    const servicesList = [
        {
            icon: <FontAwesomeIcon icon={faCoins} className="mr-sm-3" />,
            title: t('servicesPage.service1.title'),
            description: t('servicesPage.service1.description'),
            paraPreUl: t('servicesPage.service1.paraPreUl'),
            listItems: [
                t('servicesPage.service1.listItems.item1'),
                t('servicesPage.service1.listItems.item2'),
                t('servicesPage.service1.listItems.item3'),
                t('servicesPage.service1.listItems.item4'),
                t('servicesPage.service1.listItems.item5'),
            ],
            paraPostUl: t('servicesPage.service1.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faChartLine} className="mr-sm-3" />,
            title: t('servicesPage.service2.title'),
            description: t('servicesPage.service2.description'),
            description2: t('servicesPage.service2.description2'),
            paraPreUl: t('servicesPage.service2.paraPreUl'),
            listItems: [
                t('servicesPage.service2.listItems.item1'),
                t('servicesPage.service2.listItems.item2'),
                t('servicesPage.service2.listItems.item3'),
                t('servicesPage.service2.listItems.item4'),
            ],
            paraPostUl: t('servicesPage.service2.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faStar} className="mr-sm-3" />,
            title: t('servicesPage.service3.title'),
            description: t('servicesPage.service3.description'),
            description2: t('servicesPage.service3.description2'),
            paraPreUl: t('servicesPage.service3.paraPreUl'),
            listItems: [
                t('servicesPage.service3.listItems.item1'),
                t('servicesPage.service3.listItems.item2'),
                t('servicesPage.service3.listItems.item3'),
                t('servicesPage.service3.listItems.item4'),
            ],
            paraPostUl: t('servicesPage.service3.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faHouseChimney} className="mr-sm-3" />,
            title: t('servicesPage.service4.title'),
            description: t('servicesPage.service4.description'),
            description2: t('servicesPage.service4.description2'),
            paraPreUl: t('servicesPage.service4.paraPreUl'),
            listItems: [
                t('servicesPage.service4.listItems.item1'),
                t('servicesPage.service4.listItems.item2'),
                t('servicesPage.service4.listItems.item3'),
                t('servicesPage.service4.listItems.item4'),
                t('servicesPage.service4.listItems.item5'),
            ],
            paraPostUl: t('servicesPage.service4.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faVrCardboard} className="mr-sm-3" />,
            title: t('servicesPage.service5.title'),
            description: t('servicesPage.service5.description'),
            description2: t('servicesPage.service5.description2'),
            paraPreUl: t('servicesPage.service5.paraPreUl'),
            listItems: [
                t('servicesPage.service5.listItems.item1'),
                t('servicesPage.service5.listItems.item2'),
                t('servicesPage.service5.listItems.item3'),
            ],
            paraPostUl: t('servicesPage.service5.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faUsers} className="mr-sm-3" />,
            title: t('servicesPage.service6.title'),
            description: t('servicesPage.service6.description'),
            description2: t('servicesPage.service6.description2'),
            paraPreUl: t('servicesPage.service6.paraPreUl'),
            listItems: [
                t('servicesPage.service6.listItems.item1'),
                t('servicesPage.service6.listItems.item2'),
            ],
            paraPostUl: t('servicesPage.service6.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faDoorOpen} className="mr-sm-3" />,
            title: t('servicesPage.service7.title'),
            description: t('servicesPage.service7.description'),
            description2: t('servicesPage.service7.description2'),
            paraPreUl: t('servicesPage.service7.paraPreUl'),
            listItems: [
                t('servicesPage.service7.listItems.item1'),
                t('servicesPage.service7.listItems.item2'),
                t('servicesPage.service7.listItems.item3'),
            ],
            paraPostUl: t('servicesPage.service7.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faGavel} className="mr-sm-3" />,
            title: t('servicesPage.service8.title'),
            description: t('servicesPage.service8.description'),
            paraPreUl: t('servicesPage.service8.paraPreUl'),
            listItems: [
                t('servicesPage.service8.listItems.item1'),
                t('servicesPage.service8.listItems.item2'),
            ],
            paraPostUl: t('servicesPage.service8.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faMedal} className="mr-sm-3" />,
            title: t('servicesPage.service9.title'),
            description: t('servicesPage.service9.description'),
            description2: t('servicesPage.service9.description2'),
            paraPreUl: t('servicesPage.service9.paraPreUl'),
            listItems: [
                t('servicesPage.service9.listItems.item1'),
                t('servicesPage.service9.listItems.item2'),
                t('servicesPage.service9.listItems.item3'),
            ],
            paraPostUl: t('servicesPage.service9.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faFolderClosed} className="mr-sm-3" />,
            title: t('servicesPage.service10.title'),
            description: t('servicesPage.service10.description'),
            description2: t('servicesPage.service10.description2'),
            paraPreUl: t('servicesPage.service10.paraPreUl'),
            listItems: [
                t('servicesPage.service10.listItems.item1'),
                t('servicesPage.service10.listItems.item2'),
                t('servicesPage.service10.listItems.item3'),
                t('servicesPage.service10.listItems.item4'),
            ],
            paraPostUl: t('servicesPage.service10.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faMagnifyingGlass} className="mr-sm-3" />,
            title: t('servicesPage.service11.title'),
            description: t('servicesPage.service11.description'),
            description2: t('servicesPage.service11.description2'),
            paraPreUl: t('servicesPage.service11.paraPreUl'),
            listItems: [
                t('servicesPage.service11.listItems.item1'),
                t('servicesPage.service11.listItems.item2'),
                t('servicesPage.service11.listItems.item3'),
                t('servicesPage.service11.listItems.item4'),
            ],
            paraPostUl: t('servicesPage.service11.paraPostUl')
        },
        {
            icon: <FontAwesomeIcon icon={faUserTie} className="mr-sm-3" />,
            title: t('servicesPage.service12.title'),
            description: t('servicesPage.service12.description'),
            paraPreUl: t('servicesPage.service12.paraPreUl'),
            listItems: [
                t('servicesPage.service12.listItems.item1'),
                t('servicesPage.service12.listItems.item2'),
                t('servicesPage.service12.listItems.item3')
            ],
            paraPostUl: t('servicesPage.service12.paraPostUl')
        }
    ];

    const [activeServiceIndex, setActiveServiceIndex] = useState(0);
    const handleServiceClick = ( activeIndex: number) => {
        setActiveServiceIndex(activeIndex);
    };

    return (
        <>
            <Helmet>
                <title>{t('navigation.servicesLinkTitle')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={true} />

            <main id="page" className="services-page space-ptb">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <div className="services-list row">
                                {servicesList.map((service, index) => (
                                <div key={index} className="col-12">
                                    <div className={`service-item mb-4 p-3 ${activeServiceIndex === index ? 'active' : ''}`} onClick={() => handleServiceClick(index)}>
                                        <div className="d-sm-flex align-items-center text-center text-sm-left">
                                            {service.icon}
                                            <h3 className="mb-0">{service.title}</h3>
                                        </div>
                                        
                                        <div className="service-text">
                                            <p dangerouslySetInnerHTML={{ __html: service.description as string }}></p>
                                            {service.description2 && <p dangerouslySetInnerHTML={{ __html: service.description2 as string }}></p>}
                                            <p className="mb-1" dangerouslySetInnerHTML={{ __html: service.paraPreUl as string }}></p>
                                            <ul>
                                                {service.listItems.map((item, idx) => (
                                                    <li key={idx} className="mb-3" dangerouslySetInnerHTML={{ __html: item as string }}></li>
                                                ))}
                                            </ul>
                                            <p dangerouslySetInnerHTML={{ __html: service.paraPostUl as string }}></p>
                                        </div>
                                    </div>   
                                </div>
                                ))}   
                            </div>
                        </div>
                        <div className="d-none d-lg-block col-lg-6">
                            <div className="active-service-text-lg">
                                {servicesList[activeServiceIndex].description && (
                                    <p dangerouslySetInnerHTML={{ __html: servicesList[activeServiceIndex].description as string }}></p>
                                )}
                                {servicesList[activeServiceIndex].description2 && (
                                    <p dangerouslySetInnerHTML={{ __html: servicesList[activeServiceIndex].description2 as string }}></p>
                                )}
                                {servicesList[activeServiceIndex].paraPreUl && (
                                    <p dangerouslySetInnerHTML={{ __html: servicesList[activeServiceIndex].paraPreUl as string }}></p>
                                )}
                                {servicesList[activeServiceIndex].listItems && servicesList[activeServiceIndex].listItems.length > 0 && (
                                    <ul>
                                        {servicesList[activeServiceIndex].listItems.map((item, idx) => (
                                            <li key={idx} className="mb-3" dangerouslySetInnerHTML={{ __html: item as string }}></li>
                                        ))}
                                    </ul>
                                )}
                                {servicesList[activeServiceIndex].paraPostUl && (
                                    <p dangerouslySetInnerHTML={{ __html: servicesList[activeServiceIndex].paraPostUl as string }}></p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Services;